module.exports = __webpack_public_path__ + "static/img/65.81408fd.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/news/65.jpg
// module id = HWqP
// module chunks = 0